export const formatBackendDateTimeToLocal = (value: string | null | undefined, fallback = '-'): string => {
  if (!value || value.trim().length === 0) {
    return fallback;
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return fallback;
  }

  return parsedDate.toLocaleString();
};
